import React, {useState, useEffect, useContext} from 'react';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faXmark} from "@fortawesome/free-solid-svg-icons";

// Estilos
import './BtnArchivos.css'
import {COLOR_BOTONES} from '../../constants/colors';

//Contextos
import activoContext from '../../context/activoContex/activoContex';

function BtnArchivos({ files = [], selectedFiles, setSelectedFiles, modo, componentePadre = "OrdenTrabajo"}) {

    //State necesario para poder personalizar input de files.
    const [selectionColor, setSelectionColor] = useState(false);

    /* 
        Manejador encargado de eliminar archivos al requerimiento.
        Se ejecuta un borrado logico, seteando accion como DELETE para que luego sean enviados al backend y eliminados definitivamente.
    */   
    const eliminaFile = async (aborrar,index=-1) => {
        try {
            setSelectedFiles((prevFiles) => {
                let newFiles = prevFiles.slice();
                if (newFiles.new) newFiles.splice(index,1);
                else newFiles[index]['accion'] = 'DELETE';
                console.log("newFiles");
                console.log(newFiles);
                return newFiles;
            })
        } catch (error) {
            console.error("Error al eliminar el archivo", error);
        }
    };
        
    //V2 of eliminaFileNuevo
    const eliminaFileNuevo = (aborrar, index) => {
        setSelectedFiles((prevFiles) => {
            let newFiles = prevFiles.filter((f,i) => i != index);
            return newFiles;
        })
    }

    //Función necesaria para poder personalizar input de files.
    const cambioColorSeleccion = () => {setSelectionColor(!selectionColor)}

    const handleFileInputChange = (e) => {
        let files = [];
        if(e.target?.files?.length > 0){
            files = Array.from(e.target.files).map(f => ({dato:f, campo:'general', accion:'ADD', new: true}))
        }
        setSelectedFiles([...selectedFiles, ...files]);
    };

    const handlerAbrirURL = (url) => {
        window.open(url);
    }
    
    return (
        <>
            <div className='container-button'>
                <div className={selectionColor ? 'button-save-new-selected' : 'button-save-new'} style={{backgroundColor: COLOR_BOTONES}} >
                    <div className='file-select' id='src-file'>
                        <input disabled={modo === "Vista"} onFocus={cambioColorSeleccion} onBlur={cambioColorSeleccion} type="file" name="src-file" aria-label="Agregar Archivo" onChange={handleFileInputChange} multiple/>
                    </div>
                </div>
            </div>

            <div className='container-new-files'>
                <ul className='container-new-files-details'>
                    {
                        selectedFiles && Array.isArray(selectedFiles) && selectedFiles?.map((file,index) => (file.new == undefined && file.accion != 'DELETE' && file.campo != 'imagen') ? <div key={index}>
                            <div key={file?.name} > {file?.name} <span className="pdfDescarga" onClick={() => handlerAbrirURL(file?.url)}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 512 512">
                                    <path fill='#3D4D87' d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
                                </svg>
                                </span>
                                <FontAwesomeIcon onClick={() => eliminaFile(file,index)} icon={faXmark}
                                    className={`eliminar ${modo === 'Vista' ? 'ocultar' : ''}`} />
                            </div>
                        </div> : null)
                    }
                    {
                        modo !== 'Vista' && selectedFiles && Array.isArray(selectedFiles) && selectedFiles?.map((file, index) =>(file.campo === "general" && file.new && <div> 
                            <span>{file.dato.name}</span>
                            <FontAwesomeIcon onClick={() => eliminaFileNuevo(file, index)} icon={faXmark}
                            className={`eliminar ${modo === 'Vista' ? 'ocultar' : ''}`} />
                        </div>))
                    }
                </ul>
            </div>
        </>
    )

}

export default BtnArchivos;